module.exports = __webpack_public_path__ + "img/reds_bg.6a14ea39.png";